import React, { useState, useEffect, useRef } from "react";
import "./EventPage.css";
import { FaFacebookF, FaInstagram, FaGlobe, FaYoutube, FaWhatsapp, FaTiktok, FaAddressBook } from "react-icons/fa";
import competitorImages from "./catalog/competitorImages";
import sponsors from "./catalog/sponsors";
import mainSponsor from "./catalog/mainSponsor";
import { Link } from "react-router-dom";

const AudioBackground = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [volume, setVolume] = useState(0.5); // Default volume (0.0 to 1.0)
  const playerRef = useRef(null);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://w.soundcloud.com/player/api.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (isPlaying && window.SC && playerRef.current) {
      const widget = window.SC.Widget(playerRef.current);
      widget.bind(window.SC.Widget.Events.READY, () => {
        widget.setVolume(volume * 50); // Set volume (0-100 scale)
        widget.play(); // Start playback
      });
    }
  }, [isPlaying, volume]);

  const handleStart = () => {
    setIsPlaying(true);
  };

  const handleVolumeChange = (e) => {
    const newVolume = e.target.value;
    setVolume(newVolume);
    if (isPlaying && window.SC && playerRef.current) {
      const widget = window.SC.Widget(playerRef.current);
      widget.setVolume(newVolume * 50); // Update volume
    }
  };

  return (
    <>
      {!isPlaying ? (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <p></p>
          <button onClick={handleStart} >
            Iniciar experiencia con música
          </button>
        </div>
      ) : (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }} className="volume-control">
          <label>Volumen: </label>
          <input
            type="range"
            min="0"
            max="1"
            step="0.1"
            value={volume}
            onChange={handleVolumeChange}
          />
        </div>
      )}
      <iframe
        ref={playerRef}
        id="sc-player"
        width="0"
        height="0"
        scrolling="no"
        frameBorder="no"
        allow="autoplay"
        src="https://w.soundcloud.com/player/?url=https%3A%2F%2Fsoundcloud.com%2Flecastlevania%2Fnobody-gets-out-alive-pt-3&color=%23ff5500&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false&visual=false"
      ></iframe>
    </>
  );
};

const EventPage = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % competitorImages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [competitorImages.length]);

  return (
    <div className="event-container">
      
      <section className="athlete-section">
        <div className="hero-content">
          <h1>Apoya a Freddy rumbo al Mister Ecuador 2025</h1>
        </div>
        <div className="athlete-info">
          <img
            src={`${process.env.PUBLIC_URL}/images/Freddy1.png`}
            alt="Freddy"
            className="athlete-photo"
          />
          <div>
            <p>
              Campeón nacional 2023, subcampeón IFBB 2024. Mi meta es Seguir destacando en los escenarios internacionales,
              representando a mi querido Ecuador y continuar motivando a otros a alcanzar sus sueños a través del deporte. Próximas
              competencias: Mister Ecuador 2025 y Mister América 2025.
            </p>
            <video muted autoPlay loop className="athlete-video">
              <source
                src={`${process.env.PUBLIC_URL}/images/Linea.mp4`}
                type="video/mp4"
              />
              Tu navegador no soporta video.
            </video>
            <p></p>
            <a
              href="https://wa.me/593981183564"
              target="_blank"
              rel="noopener noreferrer"
              className="cta-button"
            >
              Quiero ser patrocinador
            </a>
          </div>
        </div>
      </section>

      <section className="sponsors-block">
        <h3>Nuestros Patrocinadores</h3>
        <div className="sponsors-list">
          {sponsors.map((sponsor, index) => (
            <Link
              to={`/sponsor/${sponsor.slug}`}
              key={index}
              className="sponsor-item"
              style={{
                textDecoration: "none",
                color: "inherit",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                minHeight: 260,
                padding: 12,
                width: 240, // ancho fijo para cada patrocinador
                boxSizing: "border-box"
              }}
            >
              <img
                src={sponsor.logo}
                alt={sponsor.name}
                style={{
                  display: "block",
                  margin: "0 auto 12px auto",
                  maxWidth: 120,
                  maxHeight: 80,
                  objectFit: "contain"
                }}
              />
              <p>{sponsor.name}</p>
              <p
                className="sponsor-description"
                style={{ textAlign: "left" }}
              >
                {sponsor.description.split('\n').map((line, i) => (
                  <React.Fragment key={i}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </p>
              <div
                className="sponsor-socials"
                style={{
                  marginTop: "auto", // Empuja los íconos al fondo
                  display: "flex",
                  alignItems: "center"
                }}
              >
                {sponsor.facebook && (
                  <a
                    href={sponsor.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={e => e.stopPropagation()}
                    style={{ background: "#1877f2", color: "#fff", borderRadius: "50%", padding: 6, marginRight: 4, display: "inline-flex" }}
                  >
                    <FaFacebookF />
                  </a>
                )}
                {sponsor.instagram && (
                  <a
                    href={sponsor.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={e => e.stopPropagation()}
                    style={{ background: "#e1306c", color: "#fff", borderRadius: "50%", padding: 6, marginRight: 4, display: "inline-flex" }}
                  >
                    <FaInstagram />
                  </a>
                )}
                {sponsor.tiktok && (
                  <a
                    href={sponsor.tiktok}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={e => e.stopPropagation()}
                    style={{
                      background: "#010101", // color oficial TikTok (negro)
                      color: "#fff",
                      borderRadius: "50%",
                      padding: 6,
                      marginRight: 4,
                      display: "inline-flex"
                    }}
                  >
                    <FaTiktok />
                  </a>
                )}
                {sponsor.whatsapp && (
                  <a
                    href={sponsor.whatsapp}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={e => e.stopPropagation()}
                    style={{ background: "#25D366", color: "#fff", borderRadius: "50%", padding: 6, marginRight: 4, display: "inline-flex" }}
                  >
                    <FaWhatsapp />
                  </a>
                )}
                {sponsor.youtube && (
                  <a
                    href={sponsor.youtube}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={e => e.stopPropagation()}
                    style={{ background: "#c4302b", color: "#fff", borderRadius: "50%", padding: 6, marginRight: 4, display: "inline-flex" }}
                  >
                    <FaYoutube />
                  </a>
                )}
                {sponsor.website && (
                  <a
                    href={sponsor.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={e => e.stopPropagation()}
                    style={{ background: "#00b894", color: "#fff", borderRadius: "50%", padding: 6, marginRight: 4, display: "inline-flex" }}
                  >
                    <FaGlobe />
                  </a>
                )}
                {sponsor.email && (
                  <a
                    href={sponsor.email}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={e => e.stopPropagation()}
                    style={{ background: "#00b894", color: "#fff", borderRadius: "50%", padding: 6, marginRight: 4, display: "inline-flex" }}
                  >
                    <FaAddressBook />
                  </a>
                )}
              </div>
            </Link>
          ))}
        </div>
        <a
          href="https://wa.me/593981183564"
          target="_blank"
          rel="noopener noreferrer"
          className="cta-button"
        >
          Tu marca puede estar aquí – Quiero patrocinar a Freddy
        </a>
      </section>

      {/* <section className="main-sponsor-section">
        <h3>Patrocinador Principal</h3>
        <div className="main-sponsor">
          <img
            src={mainSponsor.logo}
            alt={mainSponsor.name}
            className="main-sponsor-logo"
          />
          <p>{mainSponsor.description}</p>
          <div className="sponsor-socials">
            <a
              href="https://www.facebook.com/Carlos.Azabache.Sabando"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>
            <a
              href={mainSponsor.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaGlobe />
            </a>
          </div>
        </div>
      </section> */}

      <footer className="event-footer">
        <a
          href="https://www.azabaches.net"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/azabaches.png`}
            alt="Azabaches Logo"
            className="footer-logo"
          />
        </a>
        <p>&copy; 2025 Azabaches NET. Todos los derechos reservados.</p>
      </footer>
    </div>
  );
};

export default EventPage;